// Валидация российского СНИЛС
export const validateRussianSNILS = (snils: string): string | null => {
  if (!snils) return null;

  // Убираем все нецифровые символы
  const cleanSNILS = snils.replace(/\D/g, '');

  // Проверяем длину
  if (cleanSNILS.length !== 11) {
    return 'СНИЛС должен содержать 11 цифр';
  }

  // Проверяем, что все символы - цифры
  if (!/^\d+$/.test(cleanSNILS)) {
    return 'СНИЛС должен содержать только цифры';
  }

  // Проверяем контрольную сумму
  const checkSum = parseInt(cleanSNILS.slice(9, 11));
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanSNILS[i]) * (9 - i);
  }

  let expectedCheckSum = sum % 101;
  if (expectedCheckSum === 100 || expectedCheckSum === 0) {
    expectedCheckSum = 0;
  }

  if (checkSum !== expectedCheckSum) {
    return 'Неверная контрольная сумма СНИЛС';
  }

  return null;
};
